export default "__VITE_ASSET__C7I4nz0d__"